import React, { useEffect, useState } from 'react';
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';
import './Dashboard.css';

const Dashboard = () => {
    const [data, setData] = useState([])
    useEffect(() =>{
        fetch('data.json')
        .then(res => res.json())
        .then(data => setData(data))
    },[])
    return (
        <div>
            <div>
            <h2 className='dash-h2'>Dashboard</h2>
        </div>
        <div className='chart-container'>
        <div>
    <LineChart width={600} height={400} data={data}
    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="month" />
    <YAxis />
    <Tooltip />
    <Legend />
    <Line type="monotone" dataKey={'investment'} stroke="#8884d8" />
    <Line type="monotone" dataKey={'revenue'} stroke="#82ca9d" />
    </LineChart>
</div>

<div>
<BarChart width={600} height={400} data={data}>
  <CartesianGrid strokeDasharray="3 3" />
  <XAxis dataKey="month" />
  <YAxis />
  <Tooltip />
  <Legend />
  <Bar dataKey={'investment'} fill="#8884d8" />
  <Bar dataKey={'revenue'} fill="#82ca9d" />
</BarChart>
</div>
        </div>
        </div>
    );
};

export default Dashboard;